import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Volunteer_Navbar from './Volunteer_Navbar';
import { useNavigate } from "react-router-dom"
import './Report_page.css';
import { toast } from 'react-toastify';
import Volunteer_Header from './Volunteer_Header';
import LoadingSpinner from '../Utils/LoadingSpinner'
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import moment from "moment";
import Moment from 'react-moment';
import  { saveAs } from 'file-saver';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {   faDownload } from '@fortawesome/free-solid-svg-icons'
import ExcelJS from 'exceljs';
import DataTable  from 'react-data-table-component';



function Report_generation() {
  const IMG_BASE_URL="https://pl.aspireitacademy.com/media/";
  const volunteer = localStorage.getItem("user");
  const id = volunteer && JSON.parse(volunteer)[0].id;
  const JobfairID = volunteer && JSON.parse(volunteer)[0].V_jobfair;
  const CompanyName = volunteer && JSON.parse(volunteer)[0].V_companyname;
  const [report_query, setreport_query] = useState("");
  const navidate = useNavigate();
  const [loader,setLoader] = useState(true);
  const [filterText, setFilterText] = useState('');
  const [report_details, setreport_details] = useState([{
    "id": "",
    "jobseeker_regno": "",
    "jobfairID": "",
    "CompanyName": "",
    "status": "",
    "reporting_time": "",
    "volunteer": "",
    "updated_by": "",
    "jobdescription": "",
    "date": "",
    "jobseeker": "",
    "resume":""
  },
  ]);


const isReportDetailsEmpty = report_details.length === 0;

  const SearchFunction = (e) => {
    setreport_query(e.target.value); 
    getreport_search(e, e.target.value)
  }

  
  const getreport_details = () => {
    axios.get(`https://pl.aspireitacademy.com/Volntr_GET_jobskr/${id}`)
    .then((response) => {
      if (response.data == null) {
        toast.error("Enter correct keyword")
        setLoader(false);
      }
      else {
        setreport_details(response.data);
        setLoader(false);
      }
    }).catch(function (error) {
      toast.error("Something Went Wrong")  ;
      setLoader(false);
  })
  }
  const [report_status, setreport_status] = useState([
    {
      "id": "",
      "status": "",
    }
  ]);
  const getreport_status = () => {
    axios.get("https://pl.aspireitacademy.com/status_list").then((response) => {
      if (response.data == null) {
        toast.error("Enter correct keyword")
      }
      else {
        setreport_status(response.data);
      }
    }).catch(function (error) {
      toast.error("Something Went Wrong")  ;
     
  })
  }

  const getreport_search = (e, query) => {
    if (query.length > 0) {

      //for status new different api for fetching data
      if(query === "New"){
      
          axios.get(`https://pl.aspireitacademy.com/jobfair_applied_jobseeker/${CompanyName}/${JobfairID}`)
          .then((response) =>{
            // Convert the API response to the desired state format
            const convertedData = response.data.data.map(item => ({
               id:"",
              jobseeker_regno: item.jobseeker.register_num,
              jobfairID: item.jobfairID,
              CompanyName: item.CompanyName,
              status: "New",
              reporting_time: "",
              volunteer: "Not Available",
              updated_by: "Not Available",
              jobdescription: "",
              date: "",
              jobseeker: item.jobseeker.name.first_name,
              resume: item.resume
            }));    

           
            setreport_details(convertedData);

          }).catch( (error) => {
            toast.error("Something Went Wrong",{toastId: 'err1',})  ;
          });
      }else{
              axios.post(`https://pl.aspireitacademy.com/Volntr_jobskr_search`,
              { search_query: query, jobfair_id: JobfairID, id: id }
            ).then((response) => {
              if (response.data == null || response.data == "No Data Found" ) {
                setreport_details([]);
                    }
              else {
               
                setreport_details(response.data);
              }

            }).catch(function (error) {
              toast.error("Something Went Wrong",{toastId: 'err2',})  ;
          })

      } 
    }
  }

const handleExportExcel = (event) => {
    event.preventDefault();

  
const updatedReportDetails = report_details.map(item =>{
       return {...item,  resume:item.resume&&IMG_BASE_URL+item.resume,
        reporting_time:item.reporting_time&& moment(item.reporting_time).format("DD/MM/YYYY hh:mm:ss A")
      }
    


  // if(item.resume){
  //   return {...item,  resume: IMG_BASE_URL+item.resume,}
  // }
  // if(item.reporting_time){
  //     const repttime =  <Moment date={item.reporting_time} format="DD/MM/YYYY hh:mm:ss A"/>
  //     return {...item,  reporting_time: repttime,}
  // }
  return item;
});

    // Create a new workbook
    const workbook = new ExcelJS.Workbook();
    
    // Add a worksheet to the workbook
    const worksheet = workbook.addWorksheet(report_details[0].CompanyName);
  
    // Define the column headers
    const headers = [
      'No',
      'Register No',
      'Name',
      'Job Fair',
      'Volunteer',
      'Reporting Time',
      'Status',
      'Updated By',
      'Resume',
    ];
    worksheet.mergeCells('A1:I1');
    const companyCell = worksheet.getCell('D1');
    companyCell.value = report_details[0].CompanyName;
      // Set the horizontal alignment of the merged cell to center
  companyCell.alignment = { horizontal: 'center' };
  companyCell.font = { bold: true, size: 16 };

 
    // Add the column headers to the worksheet
    worksheet.addRow(headers);
    
    // Add the data from the report_details state array to the worksheet
    updatedReportDetails.forEach((item,index) => {
   
                    

      const rowData = [
        index+1,
        item.jobseeker_regno,
        item.jobseeker,
        item.jobfairID,
        item.volunteer,
        item.reporting_time,
        item.status,
        item.updated_by,
        item.resume ?{
          formula: `HYPERLINK("${item.resume}","Resume Link")`,
          result: item.resume
        }:'',
      ];
  
      worksheet.addRow(rowData);
    });
  
    // Generate the Excel file
    workbook.xlsx.writeBuffer().then((buffer) => {
      // Convert the buffer to a Blob
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  
      // Save the file using the FileSaver library
      saveAs(blob, 'report_details.xlsx');
    });
  };
  



  const downloadResume = (jobseeker,resume) =>{
    const url =IMG_BASE_URL+resume;
    saveAs(url,jobseeker);
}



  useEffect(() => {
   
    if (volunteer === null) {
      navidate('/Volunteer_login', {
        state: {
          user: volunteer,
        }
      });
    }
    else {
      
      getreport_details();
      getreport_status();
    }


  }, [])
 
  function convertTo12Hour(time24) {
    if(time24 !== null || time24 !== ''){
      const momentTime = moment(time24, "HH:mm");
      const formattedTime = momentTime.format("h:mm A");
      return formattedTime;
    }
   
}


//Data table structure
const customStyles = {
  headRow: {
    style: {
      color:'#fff',
      backgroundColor: '#a7a7c1',
      fontSize:"13px"
    },
  },
  rows: {
    style: {
      color: "#000",
      backgroundColor: "#fff"
    }
  },
  // cells: {
  //     style: {
  //        margin: '0px', // override the cell padding for data cells
  //         paddingRight: '0px',
  //     },
  // },
  
}

const columns = [
  {
      name: 'No',
      selector: row => row.no,
      width:"50px",
    
     
     
  },
  {
      name: 'Register No',
      selector: row => row.regno,
      sortable: true,
     
     
      
  },
  {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
      grow:2,
     
      
  },
  {
      name: 'Job Fair',
      selector: row => row.jobfair,
      sortable: true,
      grow:2,
     
  },
  {
      name: 'Volunteer',
      selector: row => row.volunteer,
      sortable: true,
     
      
  },
  {
      name: 'Reporting Time',
      selector: row => row.repttime,
      grow:2,
     
  },
  {
      name: 'Status',
      selector: row => row.status,
	  width:"150px",
     
  },
  {
      name: 'Updated By',
      selector: row => row.updtby,
  },
  {
    name: 'Resume',
    selector: row => row.resume,
    width:"100px",
},
];

const rows = report_details?report_details.filter(item=>

  item.jobseeker && item.jobseeker.toLowerCase().includes(filterText.toLowerCase()) || 
  item.jobfairID && item.jobfairID.toLowerCase().includes(filterText.toLowerCase()) ||  
  item.volunteer && item.volunteer.toLowerCase().includes(filterText.toLowerCase()) || 
  item.updated_by && item.updated_by.toLowerCase().includes(filterText.toLowerCase()))
.map((item,index) => {
  let reptime='Not Available';

  if(item.reporting_time){
      reptime = <Moment date={item.reporting_time} format="DD/MM/YYYY hh:mm:ss A"/>
     // reptime = reptime+convertTo12Hour(item.reporting_time);
  }


  return {
      no : index+1 ,
      regno:item.jobseeker_regno,
      name:item.jobseeker,
      jobfair:item.jobfairID,
      volunteer:item.volunteer,
      repttime:reptime,
      status:item.status,
      updtby:item.updated_by,
      resume:item.resume?<span className='resume_dwnload_btn'
      onClick={()=>{downloadResume(item.jobseeker,item.resume)}}>
      <FontAwesomeIcon icon={faDownload}  style={{color:'#31319b'}}/>
      </span>:'',
    
  }
}):''

  return (
    <div className="my-custom-scrollbar my-custom-scrollbar-primary">
      <section className="bg-white h-100 w-100">
      <Volunteer_Header />
        <Volunteer_Navbar />
        { loader ? <LoadingSpinner />:
        <div className="container" >
          <h4  className='text-start text-capitalize mt-4 ps-2 page-title'>Report Generation</h4>
          <hr className="search_line"></hr>
          <Form>
            <Row className='mb-2'>
              <Col  >
                <div className='status-dropdwn d-flex justfiy-content-between gap-4'>
                  <select  onChange={(e) => SearchFunction(e)} className="form-control w-25">
                    <option >-----Select Status------     ▼</option>
                    {
                      report_status.map((item,index) => {

                        return (<option value={item.status} key={index}>{item.status}</option>)
                      })
                    }
                  </select>
                  <input type="search"
                    className="form-control fs-6"
                    placeholder='Search'
                    onChange={(e) => setFilterText(e.target.value)}
                    value={filterText}
                    style={{width:'40%'}}
                    />
                </div>
                
              </Col>
              
             
              <Col xs={4}  className='text-end' >
             <button onClick={handleExportExcel} disabled={isReportDetailsEmpty} className='btn btn-primary' id='volsavebtn'>Download</button>
              </Col>
            </Row>
          </Form>
          <div className="table-responsive">
          <DataTable
                            
                            columns={columns}
                            data={rows} 
                            fixedHeader ={true} 
                            fixedHeaderScrollHeight="600px"
                            striped
                            customStyles={customStyles}  
                            persistTableHead
                            pagination
                            
                        />
          </div>
        
        </div>
}
      </section>
    </div>


  )
};
export default Report_generation;